import React from 'react'
import PropTypes from 'prop-types'

const PerformanceTable = props => {
  return (
    <React.Fragment>
      {props.subs.map((sub, i) => {
        let color
        if (sub[2] > 80) {
          color = 'success'
        } else if (sub[2] > 65 && sub[2] <= 80) {
          color = 'warning'
        } else if (sub[2] <= 65) {
          color = 'danger'
        }
        return (
          <div className="row mb-1" key={i}>
            <div className="col-md-8">
              {sub[0]}
              {sub[3] ? (
                <div className="mx-3 mb-2 icon icon_clock7 icon_color_red" />
              ) : (
                ''
              )}
            </div>
            <div className="col-md-8">{sub[1]}</div>
            <div className="col-md-8">
              <div className="progress">
                <div
                  className={`progress-bar progress-bar-${color}`}
                  style={{ width: `${sub[2]}%` }}
                >
                  {`${sub[2]}%`}
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </React.Fragment>
  )
}

export default PerformanceTable

PerformanceTable.propTypes = {
  subs: PropTypes.array,
  isLate: PropTypes.bool,
}
